import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { RecordingMethod, CourseViewModel, AuthorCourseVewModel, OrganizationCertificationViewModel } from 'src/app/_models/generatedModels';
import { ToasterService } from 'src/app/_services/toaster.service';
import { CEUService, OrganizationService, UserService } from 'src/app/_services/generatedServices';
import { Router, ActivatedRoute } from '@angular/router';
import { ValidatorHelper } from 'src/app/_helpers/validationHelper';
import Editor from "../../../ckCustomBuild/ckeditor";
import * as customBuild from 'src/ckCustomBuild/ckeditor';


@Component({
  selector: 'bxl-author-course',
  templateUrl: 'author-course.component.html',
})
export class AuthorCourseComponent implements OnInit {
  initialized = false;
  public formGroup: FormGroup;
  submitComplete: Promise<{}> | undefined;
  RecordingMethod = RecordingMethod;
  certifications: OrganizationCertificationViewModel[];
  public Editor:any = customBuild;

  constructor(private route: ActivatedRoute, private ceuService: CEUService, private orgData: OrganizationService, private router: Router, private fb: FormBuilder, private toaster: ToasterService, private userService: UserService) {}



  htmlEditorConfig = {
    toolbar: {
      items: ['bold', 'italic', 'underline', 'link', 'alignment', 'outdent', 'indent', 'bulletedList', 'numberedList', '|', 'fontFamily', 'fontSize', 'fontColor', 'fontBackgroundColor', 'SourceEditing'],
      shouldNotGroupWhenFull: false,
    },
    fontSize: {
      options: [9, 11, 13, 'default', 17, 19, 21],
    },
    mediaEmbed: {
      previewsInData: true,
    },
  };

  ngOnInit(): void {
    this.ceuService.getCertificationsForPlatform().subscribe((data) => {
      this.certifications = data;
      this.setupForm();
    });
  }

  setupForm(): any {
    this.formGroup = this.fb.group({
      title: ['', [Validators.required]],
      recordingMethod: ['', Validators.required],
      price: ['', [Validators.required]],
      description: ['', [Validators.required]],
      ceus: this.fb.array([]),
    });

    this.loadCEUs();

    this.initialized = true;
  }

  loadCEUs() {
    let ceus = this.formGroup.get('ceus') as FormArray;

    this.certifications.forEach((cert) => {
      var array = this.fb.group(
        {
          certificationBodyId: [cert.certificationBodyId],
          ceuCount: [, [Validators.required]],
          subType1CeuCount: [, [Validators.required]],
          subType2CeuCount: [, [Validators.required]],
          subType3CeuCount: [, [Validators.required]],
        },
        { validators: [ValidatorHelper.totalCEUValidator()], updateOn: 'change' }
      );

      if (cert.certificationBody.subType1Name == null) {
        console.log('clearing validators');
        array.controls.subType1CeuCount.clearValidators();
      }

      if (cert.certificationBody.subType2Name == null) {
        console.log('clearing validators');
        array.controls.subType2CeuCount.clearValidators();
      }

      if (cert.certificationBody.subType3Name == null) {
        console.log('clearing validators');
        array.controls.subType3CeuCount.clearValidators();
      }

      ceus.push(array);
    });
  }

  onSave() {
    if (!this.formGroup.valid) {
      this.formGroup.markAllControlsDirty();
      this.toaster.error('Please fill out all required fields', 'Error');
      return;
    }
    this.submitComplete = new Promise((resetButton: any, reject) => {
      const formData: AuthorCourseVewModel = Object.assign({}, null, this.formGroup.value);

      this.userService.submitCourse(formData).subscribe(
        (course) => {
          this.toaster.success('Course Added', 'Success');
          this.navigateBack(course.id);
          resetButton();
        },
        (error) => resetButton()
      );
    });
  }

  navigateBack(courseId: number) {
    if (this.formGroup.controls['recordingMethod'].value === RecordingMethod.Self) {
      this.router.navigate([courseId, 'upload'], { relativeTo: this.route });
    } else {
      this.toaster.messageDialog('Your course has been submitted. You will be contacted by a member of our staff to schedule your recording.', 'Submitted').subscribe((result) => {});
      this.router.navigate(['./listings'], { relativeTo: this.route.parent });
    }
  }

  onCancel() {
    this.router.navigate(['./listings'], { relativeTo: this.route.parent });
  }
}
